import type { CSSProperties } from 'react';

import { cx } from './classNames';
import { resolveIconClass } from './icons';

/** Pendant zu `SfIcon`. */
export interface IconProps {
  /** Syncfusion- oder Font-Awesome-Angabe, z. B. `"e-icons e-plus"`. */
  iconClass: string | undefined;
  id?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
}

export function Icon(props: IconProps) {
  const resolved = resolveIconClass(props.iconClass);
  if (resolved === undefined) return null;

  return (
    <span
      id={props.id}
      className={cx('e-icons', resolved, props.className)}
      style={props.style}
      title={props.title}
      aria-hidden="true"
    />
  );
}

export default Icon;
